import { FourOOne } from './401'
import { FourOThree } from './403'
import { FourOFour } from './404'
import { FourTwoTwo } from './422'
import { FiveHundred } from './500'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { useEventTracking } from '../../hooks'

function getErrorPage(errorCode?: number) {
  const code = errorCode ?? 500
  switch (code) {
    case 404:
      return FourOFour
    case 422:
      return FourTwoTwo
    case 401:
      return FourOOne
    case 403:
      return FourOThree
    default:
      return FiveHundred
  }
}

interface IErrorPageProps {
  errorCode?: number
}

export const ErrorPage = ({ errorCode }: IErrorPageProps) => {
  const Page = getErrorPage(errorCode)

  return <Page />
}

export const ErrorElement = () => {
  const error = useRouteError()
  const { trackError } = useEventTracking('Error Element')
  trackError({ event: 'Error Element', error: error as Error })
  if (isRouteErrorResponse(error)) {
    return <ErrorPage errorCode={error.status} />
  }
  return <ErrorPage errorCode={500} />
}
